import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from '../styles/PracticasConvenio.styles';
import { formatFechaCorta, getEstadoVencimiento } from '../utils/formatters';

const BadgeVencimiento = ({ fechaFinVigencia }) => {
  const classes = useStyles();
  const estadoVencimiento = getEstadoVencimiento(fechaFinVigencia);

  return (
    <Box className={`${classes.vencimientoBox} ${estadoVencimiento === 'vencido' ? classes.vencimientoVencido : ''}`}>
      <Typography variant="caption" color="textSecondary">
        Vence
      </Typography>
      <Typography variant="body2">
        {formatFechaCorta(fechaFinVigencia) || '-'}
      </Typography>
    </Box>
  );
};

export default BadgeVencimiento;
